import React, { Component } from 'react';

import OpenSourceProject from './open-source-project';
import LoadingIndication from '../common/loading-indicator';
import AnimatedWrapper from '../core/animated-wrapper';
import shareService from '../../services/share';
import openSourceService from '../../services/open-source';
import SmartAd from '../ads/smart-ad';
import AdUIService from '../../services/ads/ui';

import './open-source.css';

class OpenSource extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,
      projects: [],
    };

    shareService.setupPage({
      title: "Open source projects gallery",
      isTitlePrefixOn: false,
      tags: ["opensource", "javascript", "webdev"]
    });
  }

  componentDidMount() {
    openSourceService.getProjects()
      .then((projects) => {
        this.setState({
          isLoading: false,
          projects: projects
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }
  
  getProjectsPartJSX() {
    if (this.state.projects.length === 0) {
      return (
        <p>There is no projects</p>
      );
    }

    const projects = this.state.projects.map((project) => 
      <OpenSourceProject {...project} key={`open-source-project-${project._id}`} />
    );

    return AdUIService.putEvery(projects, SmartAd, 1, 3);
  }

  render() {
    let extraJSX;
    
    if (this.state.isLoading) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      extraJSX = (
        <div className='projects'>
          {this.getProjectsPartJSX()}
        </div>
      );
    }

    return (
      <section className='regular-page open-source-page'>
        <div className='open-source-container'>
          <h3 className='page-title'>Open Source</h3>
          <hr className='title-separator' />

          {extraJSX}
        </div>
      </section>
    );
  }
}

const AnimatedOpenSource = AnimatedWrapper(OpenSource);
export default AnimatedOpenSource;